import { axios, handleApiError } from "./Api";

const MenusApi = {
  /**
   * Get active Menus on date
   *
   * @param {moment} Date
   */
  async getMenuActiveOn(date) {
    return axios
      .get(axios.defaults.baseURL + "/menus/" + date.format("YYYY-MM-DD"))
      .then(response => {
        return response.data.menus;
      })
      .catch(handleApiError);
  },

  /**
   * Get Meals for Menu on a specific date
   *
   * @param {Number} menu_id
   * @param {moment} date
   * @param {Number} clientId
   * @returns Promise
   */
  async getMealsForMenuOnDate(menu_id, date, clientId) {
    return axios
      .get(`menu/${menu_id}/meals/${date.format('YYYY-MM-DD')}?clientId=${clientId}`)
      .then(response => {
        return response.data.meals;
      })
      .catch(handleApiError);
  },

  /**
   * Get Meals for Menu
   * 
   * @param {Number} menu_id 
   * @param {Number} clientId
   */
  async getMealsForMenu(menu_id, clientId) {
    return axios
      .get(`/menu/${menu_id}/meals?clientId=${clientId}`)
      .then(response => {
        return response.data.meals;
      })
      .catch(handleApiError);
  }
};

export default MenusApi;
